import { render, staticRenderFns } from "./DialogFormActivityEdit.vue?vue&type=template&id=2841eb76"
import script from "./DialogFormActivityEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormActivityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports